import Vue from 'vue'
import Router from 'vue-router'
import home from '@/components/home'
import homeedit from '@/components/homeedit'
// import ck from '@/components/ck'
// import ckedit from '@/components/ckedit'
import login from '@/components/login'
import verifyok from '@/components/verifyok'
import mine from '@/components/mine'
import about from '@/components/about'
import intrIndex from '@/components/intr_index'
import intrPrice from '@/components/intr_price'
import intrGoods from '@/components/intr_goods'
import intrCalc from '@/components/intr_calc'
import feed from '@/components/feed'
import charge from '@/components/charge'
import setpwd from '@/components/setpwd'
import chatgpt from '@/components/chatgpt'
import brand from '@/components/brand'
import juliang from '@/components/juliang'
import intrCode from '@/components/intr_code'

Vue.use(Router)

var meta = {
  title: '百度指数一键下载导出工具-草莓数据',
  content: {
    keywords: '百度指数一键下载,百度指数批量下载,查询,关键词,百度指数导出',
    description: '百度指数一键下载，百度指数导出数据，使用本站可以百度指数一键下载，告别四处求人，自己轻松导出百度指数到Excel，采集设置灵活，随心所欲的设置。数据采集结果直观。'
  }
}
var metajl = {
  title: '抖音指数一键下载导出工具-草莓数据',
  content: {
    keywords: '抖音指数一键下载采集导出工具,抖音指数关键词指数批量下载,查询,关键词,抖音指数导出',
    description: '抖音指数一键下载，使用本站可以把抖音指数一键下载，告别四处求人，自己轻松导出抖音指数到Excel，采集设置灵活，随心所欲的设置。数据采集下载结果直观。'
  }
}
export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'home',
      meta: meta,
      component: home
    },
    {
      path: '/homeedit',
      name: 'homeedit',
      meta: meta,
      component: homeedit
    },
    {
      path: '/juliang',
      name: 'juliang',
      meta: metajl,
      component: juliang
    },
    {
      path: '/mine',
      name: 'mine',
      meta: meta,
      component: mine
    },
    {
      path: '/about',
      name: 'about',
      meta: meta,
      component: about
    },
    {
      path: '/introne',
      name: 'intrIndex',
      meta: meta,
      component: intrIndex
    },
    {
      path: '/intrprice',
      name: 'intrPrice',
      meta: meta,
      component: intrPrice
    },
    {
      path: '/intrGoods',
      name: 'intrGoods',
      meta: meta,
      component: intrGoods
    },
    {
      path: '/intrcalc',
      name: 'intrCalc',
      meta: meta,
      component: intrCalc
    },
    {
      path: '/intrcode',
      name: 'intrCode',
      meta: meta,
      component: intrCode
    },
    {
      path: '/login',
      name: 'login',
      meta: meta,
      component: login
    },
    {
      path: '/setpwd',
      name: 'setpwd',
      meta: meta,
      component: setpwd
    },
    {
      path: '/verify/:t',
      name: 'verify',
      component: verifyok
    },
    {
      path: '/charge/:c',
      name: 'charge',
      component: charge
    },
    {
      path: '/feed',
      name: 'feed',
      meta: meta,
      component: feed
    },
    {
      path: '/brand',
      name: 'brand',
      meta: meta,
      component: brand
    },
    {
      path: '/chatgpt',
      name: 'chatgpt',
      meta: meta,
      component: chatgpt
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js